module.exports = __webpack_public_path__ + "page_down.png";